<script>
import { runWhenCookiebotConsentGranted } from '~/app/cookiebot'
import { trackHeurekaProductDetail } from '~/sites/cvb/heureka/directConversions'
import Component from '~/sites/shop/pages/product/_slug'
import contentSettings from '@site/content.settings'

export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/produkt/:slug',
      de: '/produkt/:slug',
      en: '/product/:slug',
      sk: '/produkt/:slug',
    },
  },
  beforeDestroy() {
    if (typeof this.heurekaProductPageViewConsentDisposer === 'function') {
      this.heurekaProductPageViewConsentDisposer()
      this.heurekaProductPageViewConsentDisposer = null
    }
  },
  methods: {
    sendProductPageViewEvent() {
      Component.methods.sendProductPageViewEvent.call(this)

      if (typeof this.heurekaProductPageViewConsentDisposer === 'function') {
        this.heurekaProductPageViewConsentDisposer()
        this.heurekaProductPageViewConsentDisposer = null
      }

      this.heurekaProductPageViewConsentDisposer = runWhenCookiebotConsentGranted(
        contentSettings,
        ['marketing'],
        () => {
          trackHeurekaProductDetail(this)
        },
      )
    },
  },
}
</script>
